import Image from 'next/image';

import { Static } from '@/components/static-section';
import { Partner, partner_intro, partners } from '@/data/site-content';


export const Partners = (props: Props) => {
  return (
    <Static backgroundColor="bg-white" textColor="text-dark" id="partners">
      <div className="sub-grid overflow-clip py-[83px] tablet:py-[120px] desktop:py-[160px] desktopXL:py-[295px]">
        <div className="col-span-full">
          <h2
            className="kerning-[-2%] liga mb-[78px] font-heldane text-homeStyle3 font-normal leading-[120%] text-dark tablet:mb-[74px] desktop:mb-[60px] desktopXL:mb-[82px]"
            dangerouslySetInnerHTML={{ __html: partner_intro.title || '' }}
          />
        </div>
        <div className="kerning-[-2%] col-span-full grid grid-cols-12 gap-y-[44px] text-dark desktop:gap-y-[64px] desktopXL:gap-y-[120px]">
          {partners.map((item, index) => (
            <PartnerItem
              title={item.title}
              description={item.description}
              imageUrl={item.imageUrl}
              imageHeight={item.imageHeight}
              imageWidth={item.imageWidth}
              link={item.link}
              key={index}
            />
          ))}
        </div>
      </div>
    </Static>
  );
};

const PartnerItem = ({
  imageUrl = '',
  title = '',
  description = '',
  imageWidth = 129,
  imageHeight = 93,
  link = '',
}: Partner) => (
  <div className="col-span-11 flex flex-row gap-x-[20px] tablet:col-span-4 tablet:gap-x-[clamp(14px,calc(14px+(28-14)*(100vw-375px)/(1920-375)),28px)] desktop4k:gap-x-[24px]">
    {imageUrl ? (
      <Image
        className="h-[76px] w-[76px] tablet:h-[49px] tablet:w-[49px] desktop:h-[66px] desktop:w-[66px] desktopXL:h-[101px] desktopXL:w-[101px] desktop4k:h-[124px] desktop4k:w-[124px]"
        src={imageUrl}
        width={imageWidth}
        height={imageHeight}
        alt={`${title} logo: ${description}`}
      />
    ) : (
      <div className="mb-[24px] h-full w-full bg-dark/20" />
    )}

    <div className="pr-[clamp(0px,calc(0px+(92-0)*(100vw-375px)/(1920-375)),92px)] desktop4k:pr-[29%]">
      <a href={link} className="hover:underline" rel="external nofollow">
        <h4 className="relative -top-1 text-[18px] font-halbfett leading-normal tracking-[-2%] tablet:top-0 tablet:mb-[5px] tablet:text-[24px] desktop:text-[24px] desktopXL:text-[24px] desktop4k:text-[28px]">
          {title}
        </h4>
      </a>
      <p className="liga pr-0 font-heldane text-[18px] font-normal leading-[120%] tablet:pr-0 tablet:text-[23px] desktop:text-[23px] desktopXL:text-[23px] desktop4k:text-[26px]">
        {description}
      </p>
    </div>
  </div>
);
